import { NuxtCookies } from 'cookie-universal-nuxt';
import {
  SALESGPT_SIGN_IN_AB_TEST,
  SALESGPT_SIGN_IN_AB_TEST_QUERY,
} from '@/components/common/UniversalSearch/constants';

// a - current behavior with sign up
// b - new behavior without sign up
type AbTestBranch = 'a' | 'b';

const COOKIES_EXPIRATION = 60 * 60 * 24 * 30; // 30 days
const MAX_QUERIES = 1;

const getCookieValue = (cookies: NuxtCookies, key: string) => cookies.get(key) || cookies.get(key, { fromRes: true });

export const abTest = {
  getQuery(cookies: NuxtCookies): string[] {
    try {
      const value = getCookieValue(cookies, SALESGPT_SIGN_IN_AB_TEST_QUERY);
      if (!value) return [];
      return JSON.parse(value);
    } catch (_) {
      return [];
    }
  },
  setQuery(cookies: NuxtCookies, value: string) {
    const newValue = Array.from(new Set([...this.getQuery(cookies), value]));
    // we do not want to add more queries to cookie than we need
    if (newValue.length <= MAX_QUERIES + 1) {
      cookies.set(SALESGPT_SIGN_IN_AB_TEST_QUERY, newValue, { path: '/', maxAge: COOKIES_EXPIRATION });
    }
  },
  getBranch(cookies: NuxtCookies): AbTestBranch | undefined {
    return getCookieValue(cookies, SALESGPT_SIGN_IN_AB_TEST);
  },
  setBranch(cookies: NuxtCookies, value: AbTestBranch) {
    cookies.set(SALESGPT_SIGN_IN_AB_TEST, value, { path: '/', maxAge: COOKIES_EXPIRATION });
  },
  remove(cookies: NuxtCookies) {
    cookies.remove(SALESGPT_SIGN_IN_AB_TEST);
    cookies.remove(SALESGPT_SIGN_IN_AB_TEST_QUERY);
  },
  shouldApply(cookies: NuxtCookies) {
    if (this.getBranch(cookies)) return false;
    const shouldRandomlyApply = Math.random() >= 0.5;
    this.setBranch(cookies, shouldRandomlyApply ? 'b' : 'a');
    return shouldRandomlyApply;
  },
  isInControlBranch(cookies: NuxtCookies) {
    return this.getBranch(cookies) === 'a';
  },
  isEnrolled(cookies: NuxtCookies) {
    return this.getBranch(cookies) === 'b';
  },
  isLimitReached(cookies: NuxtCookies) {
    return this.getQuery(cookies).length > MAX_QUERIES;
  },
};
